import {
    GET_JOBTYPE_REQUEST, GET_JOBTYPE_SUCCESS, GET_JOBTYPE_FAIL, CREATE_JOBTYPE_REQUEST, CREATE_JOBTYPE_SUCCESS, CREATE_JOBTYPE_FAIL, EDIT_JOBTYPE_REQUEST, EDIT_JOBTYPE_SUCCESS, EDIT_JOBTYPE_FAIL, DELETE_JOBTYPE_REQUEST, DELETE_JOBTYPE_SUCCESS, DELETE_JOBTYPE_FAIL, CREATE_JOBTYPE_RESET, EDIT_JOBTYPE_RESET, DELETE_JOBTYPE_RESET, START_JOB_REQUEST, START_JOB_SUCCESS, START_JOB_FAIL, GET_JOBS_REQUEST, GET_JOBS_SUCCESS, GET_JOBS_FAIL, GET_JOB_REQUEST, GET_JOB_SUCCESS, GET_JOB_FAIL, START_JOB_RESET
} from '../constants/jobConstants';

export const getJobTypesReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_JOBTYPE_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_JOBTYPE_SUCCESS:
            return { ...state, loading: false, jobTypes: action.payload, error: null };
        case GET_JOBTYPE_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export const jobTypeCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_JOBTYPE_REQUEST:
            return { ...state, loading: true, error: null };
        case CREATE_JOBTYPE_SUCCESS:
            return { ...state, loading: false, createJobType: action.payload, error: null };
        case CREATE_JOBTYPE_FAIL:
            return { ...state, loading: false, error: action.payload };
        case CREATE_JOBTYPE_RESET:
            return { ...state, loading: false, createJobType: null, error: action.payload };
        default:
            return state;
    }
};

export const jobTypeEditReducer = (state = {}, action) => {
    switch (action.type) {
        case EDIT_JOBTYPE_REQUEST:
            return { ...state, loading: true, error: null };
        case EDIT_JOBTYPE_SUCCESS:
            return { ...state, loading: false, editJobType: action.payload, error: null };
        case EDIT_JOBTYPE_FAIL:
            return { ...state, loading: false, error: action.payload };
        case EDIT_JOBTYPE_RESET:
            return { ...state, loading: false, editJobType: null, error: action.payload };
        default:
            return state;
    }
};

export const jobTypeDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_JOBTYPE_REQUEST:
            return { ...state, loading: true, error: null };
        case DELETE_JOBTYPE_SUCCESS:
            return { ...state, loading: false, deleteJobType: action.payload, error: null };
        case DELETE_JOBTYPE_FAIL:
            return { ...state, loading: false, error: action.payload };
        case DELETE_JOBTYPE_RESET:
            return { ...state, loading: false, deleteJobType: null, error: action.payload };
        default:
            return state;
    }
};

export const startJobReducer = (state = {}, action) => {
    switch (action.type) {
        case START_JOB_REQUEST:
            return { ...state, loading: true, error: null };
        case START_JOB_SUCCESS:
            return { ...state, loading: false, startJob: action.payload, error: null };
        case START_JOB_FAIL:
            return { ...state, loading: false, error: action.payload };
        case START_JOB_RESET:
            return { ...state, loading: false, startJob: null, error: action.payload };
        default:
            return state;
    }
};

export const getJobsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_JOBS_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_JOBS_SUCCESS:
            return { ...state, loading: false, jobs: action.payload, error: null };
        case GET_JOBS_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};


export const getJobReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_JOB_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_JOB_SUCCESS:
            return { ...state, loading: false, job: action.payload, error: null };
        case GET_JOB_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};